import { initializeConflictsView } from '../actions/publicActions';
import getStore from '../store/store';
import { mutator } from 'satcheljs';
import {
    navigateToNextInstance,
    navigateToPreviousInstance,
    setFutureInstances,
} from '../actions/timePanelConflictsViewActions';

mutator(initializeConflictsView, ({ meetingRequest }) => {
    const store = getStore();

    store.meetingRequest = meetingRequest;
    store.selectedInstanceIndex = 0;
});

mutator(setFutureInstances, ({ futureInstances }) => {
    const store = getStore();
    if (!store.meetingRequest) {
        return;
    }

    store.futureInstances = futureInstances;
});

mutator(navigateToPreviousInstance, () => {
    const { selectedInstanceIndex, futureInstances } = getStore();
    getStore().selectedInstanceIndex =
        // JS % operator can produce negative values if the left side is negative.
        // Add futureInstances.length to ensure the result of % is always positive
        (selectedInstanceIndex - 1 + futureInstances.length) % futureInstances.length;
});

mutator(navigateToNextInstance, () => {
    const { selectedInstanceIndex, futureInstances } = getStore();
    getStore().selectedInstanceIndex = (selectedInstanceIndex + 1) % futureInstances.length;
});
